/** @format */

import {CompanyUsersList} from './company_users_list';
import {Loading, useFetch} from 'frontier-utilities';
import {Tab, Tabs} from '@sttark/design-system';
import React, {useState, useMemo} from 'react';
import {RequestsList} from './requests_list';
import CreateCompany from './create_company';
import {Toast} from '@sttark/design-system';
import {RequestAdd} from './request_add';
import './container.scss';

const CompaniesContainer = () => {
    const [activeTab, setActiveTab] = useState('active');
    const [requests, setRequests] = useState([]);
    const [company, setCompany] = useState({});
    const [toast, setToast] = useState({
        isDanger: false,
        isOpen: false,
        message: ''
    });

    const queryParams = useMemo(
        () =>
            new Proxy(new URLSearchParams(window.location.search), {
                get: (searchParams, prop) => searchParams.get(prop)
            }),
        []
    );

    const onTabChangeTab = tab => {
        setActiveTab(tab);
    };

    // get the company
    const {isLoading: isCompanyUsersLoading, fetchData: fetchCompany} = useFetch(
        '/account/companies/get-for-user',
        res => {
            setCompany(res.company);
        }
    );

    // get the merge requests for the company
    const {isLoading: isMergeRequestsLoading, fetchData} = useFetch(
        '/account/user-merge-requests/get-for-company-id',
        res => {
            setRequests(res.requests);
        }
    );

    const hideToast = () => {
        setToast({
            isDanger: false,
            isOpen: false,
            message: ''
        });
    };

    const handleSuccessfulSend = requests => {
        setToast({
            isDanger: false,
            isOpen: true,
            message: 'Request sent successfully.'
        });
        fetchData();
    };

    const handleSuccessfulCompanyCreate = company => {
        fetchCompany();
        setToast({
            isDanger: false,
            isOpen: true,
            message: 'Company created successfully.'
        });
    };

    const archivedUsers = company.users?.filter(user => !user.is_active);
    const activeUsers = company.users?.filter(user => user.is_active);

    const isLoading = isCompanyUsersLoading || isMergeRequestsLoading;

    if (isLoading) {
        return <Loading message="Loading Company" />;
    }

    if (company && !company.id) {
        return <CreateCompany onCreate={handleSuccessfulCompanyCreate} />;
    }

    return (
        <div className="user-manage-company-21kv">
            <Toast
                danger={toast.isDanger}
                autoHideDuration={4000}
                isOpen={toast.isOpen}
                onClose={hideToast}
                zIndex={3001}
                autoHide>
                <p className="color-structure-white m-0">{toast.message}</p>
            </Toast>
            {queryParams.merge === 'false' && (
                <div className="alert alert-danger">
                    Adding the user to the new company failed. Either the request has expired or the
                    company no longer exists.
                </div>
            )}
            <div className="d-flex align-items-center justify-content-end gap-4">
                <RequestAdd companyId={company.id} onSuccessfulSend={handleSuccessfulSend}>
                    <button className="btn btn--primary py-0 d-flex align-items-center">
                        <b>Invite User</b>
                    </button>
                </RequestAdd>
                {/* Leaving out for now */}
                {/*<button className="btn btn--secondary py-0 d-flex align-items-center">
                        <b>Transfer Ownership</b>
                    </button>*/}
            </div>
            <Tabs activeTab={activeTab} onChange={onTabChangeTab} className={'tabs mb-0'}>
                <Tab title={`Active Users (${activeUsers.length})`} name="active">
                    <CompanyUsersList users={activeUsers} />
                </Tab>
                <Tab title={`Archived Users (${archivedUsers.length})`} name="archived">
                    <CompanyUsersList users={archivedUsers} />
                </Tab>
                <Tab title={`Pending Users (${requests?.length})`} name="pending">
                    <RequestsList users={requests} />
                </Tab>
            </Tabs>
            {/*<UserMergeRequests company_id={company.id} />*/}
        </div>
    );
};

export default CompaniesContainer;
